<div class="d-flex align-items-center mb-1">
  <ng-container *ngIf="isBeingModified; else displayValue">
    <input #inputTitle mdbInput type="text" class="h2-input" [formControl]="control" [maxlength]="maxlength" (blur)="isBeingModified = false" jhiMarkAsterisk />
  </ng-container>
  <ng-template #displayValue>
    <h2 class="mb-0">{{ value }}</h2>
    <mdb-icon fas icon="pen-to-square" class="ml-2" (click)="toModify()"></mdb-icon>
  </ng-template>
</div>
